// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"InterstitialLoader-fe6e4ce0609c95bb","background":"InterstitialLoader-d94459d8723b8e69","fullScreen":"InterstitialLoader-56ee0034690da67f"};